import React, { useState } from 'react';
import { Link } from '@mui/material';

const ExpandableCell = ({ value, maxLength = 200 }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div>
      <span style={{ display: 'inline' }}>
        {expanded ? value : value.slice(0, maxLength)}
        {value.length > maxLength && (
          <>
            &nbsp;
            <Link
              type="button"
              component="button"
              sx={{
                fontSize: 'inherit',
                letterSpacing: 'inherit',
                verticalAlign: 'baseline', 
                padding: 0, 
                lineHeight: 1,
              }}
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? 'view less' : 'view more'}
            </Link>
          </>
        )}
      </span>
    </div>
  );
};

export default ExpandableCell;
